export default {
  LOGIN: `Connexion`,
  SUBMIT: `Envoyer`,
  COMPANY: {
    LABEL: `Compagnie`,
    PLACEHOLDER: ``,
    DESCRIPTION: `Entrez le début de l'URL de votre compagnie`
  },
  USERNAME: {
    LABEL: `Identifiant`,
    PLACEHOLDER: `Entrez un courriel, numéro d'employé ou nom d'utilisateur`,
    DESCRIPTION: ``
  },
  EMAIL: {
    LABEL: `Addresse courriel`,
    PLACEHOLDER: `Veuillez entrer votre addresse courriel`,
    DESCRIPTION: `Vous devez utiliser un courriel lié à votre compte`
  },
  USERNAMEOREMAIL: {
    LABEL: `Nom d'utilisateur ou addresse courriel`,
    PLACEHOLDER: `Veuilllez entrer votre nom d'utilisateur ou addresse courriel`,
    DESCRIPTION: `Vous devez utiliser un courriel lié à votre compte`
  },
  PASSWORD: {
    LABEL: `Mot de passe`,
    PLACEHOLDER: `Entrez votre mot de passe`,
    DESCRIPTION: ``
  },
  REQUIRED: `Ce champ est requis.`,
  USERNAME_CANT_BE_COMPANY: `Vous avez entré le nom de l'entreprise plutôt que votre nom d'utilisateur.`,
  TOO_SHORT: `Contenu trop court`,
  TOO_LONG: `Contenu trop long`,
  FORGOT_PASSWORD: `Mot de passe oublié?`,
  FORGOT_PASSWORD_CARD: {
    TITLE: `Mot de passe oublié`,
    SUMMARY: `Afin de re-initialiser votre mot de passe, veuillez entrer votre courriel ci-dessous.`
  },
  FORGOT_USERNAME: `Nom d'utilisateur oublié?`,
  FORGOT_USERNAME_CARD: {
    TITLE: `Nom d'utilisateur oublié`,
    SUMMARY: `Afin de retrouver votre nom d'utilisateur, veuillez entrer votre courriel ci-dessous.`
  },
  FORGOT_COMPANY: {
    TITLE: `Nom de la compagnie oublié?`,
    SUMMARY: `Retrouvez l'URL de votre compagnie en utilisant votre adresse courriel.`
  },
  forgotCompany: {
    EMAIL_SENT_TO_THIS_EMAIL: `Un courriel vous a été envoyé avec l'URL de la compagnie`,
    NO_COMPANY_FOUND_FOR_THIS_EMAIL: `Aucune compagnie n'est associée à cette adresse courriel`
  },
  MUST_BE_A_VALID_EMAIL: `L'adresse courriel doit être valide.`,
  USERNAME_PASSWORD_INVALID: `Mot de passe ou nom d'utilisateur invalide`,
  USERNAME_EMAIL_NOT_FOUND: `Nom d'utilisateur ou adresse courriel introuvable, veuillez contacter votre superviseur`,
  NO_USERNAME_EMAIL_ASSOCIATED: `Aucun compte n'est associé à cette adresse courriel ni à ce nom d'utilisateur, veuillez contacter votre superviseur`,
  EMAIL_NOT_FOUND: `Adresse courriel introuvable, veuillez contacter votre superviseur`,
  NEED_USERNAME: `Plusieurs utilisateurs possèdent également cette adresse courriel, veuillez entrer votre nom d'utilisateur`,
  SAME_EMAIL_CONTACT_MANAGER: `Plusieurs utilisateurs possèdent également cette adresse courriel, veuillez contacter votre responsable`,
  RETURN: `Retourner à la page d'authentification`,
  LOGIN_ERROR: `Erreur de connexion `,
  INVALID_COMPANY: `La compagnie ({{ co }}) que vous avez entrer est invalide.`,
  NO_COMPANY_EXISTS_ON_URL: `Aucune compagnie n'est associée à cette adresse {{ co }}.merinio.com.`,
  FIND_MY_COMPANY: `Rechercher ma compagnie`,
  RETURN_COMPANY: `Retour`,
  EMAIL_PASSWORD_CONFIRMATION: `Le lien de réinitialisation de votre mot de passe a été envoyé par courriel!`,
  EMAIL_USERNAME_CONFIRMATION: `Le lien de récupération de votre nom d'utilisateur a été envoyé par courriel!`,
  EMAIL_COMPANY_CONFIRMATION: `L'url de votre compagnie a été envoyé par courriel!`,
  NO_INTERNET: `Il semble que vous n'êtes pas connecté à Internet.`
}
